import cloneDeep from 'lodash/cloneDeep'

export default (state = [], action) => {
  let { type, payload } = action
  let newState = cloneDeep(state)
  switch (type) {
    case 'FOLLOWING_SET':
      return payload
    case 'FOLLOW_CREATE':
      let existing = newState.filter(f => f.id === payload.id)
      if (existing && existing.length > 0) {
        existing = existing[0]
        existing.followingThem = true
      } else {
        newState.push(payload)
      }

      return newState
    case 'FOLLOW_DELETE':
      newState.map(f => {
        if (f.id === payload) {
          f.followingThem = false
        }
      })
      return newState
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
